import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import orderBy from 'lodash/orderBy'
import axios from 'axios'
import qs from 'qs'

import { N, ONE, ZERO } from '@/scripts/constants/booleans'
import {
  CART_SAVED,
  IS_CSR,
  MINIWISHLIST_SAVED,
  WC_SESSION_ESTABLISHED,
} from '@/scripts/constants/cookies'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { CART_CALL_PAGES_NEEDED, SHOP_CART, WISHLIST_VIEW } from '@/scripts/constants/pages'
import {
  ALL_ELECTRONICS_PRODUCT_TYPES,
  IS_SEMIPRIVATE,
  OPTICAL,
  PUBLIC,
  REMIXABLE,
  RX,
  STD,
} from '@/scripts/constants/pdp'
import { PREORDER_AVAILABLE_ANALYTICS } from '@/scripts/constants/pdp'
import { RB } from '@/scripts/constants/store'
import { Cookies } from '@/scripts/libs/cookies'
import AlgoliaAnalytics from '@/scripts/libs/algolia/analytics'
import {
  isProductOpticalOrSun,
  isProductStellaByProductType,
  prepareParamsForAddToBag,
  getProductStatusAnalytics,
} from '@/scripts/libs/products'
import makeDebug from 'debug'
import {
  TRACKER_ADDTOCART,
  TRACKER_ADDTOWISHLIST,
  TRACKER_ERROR_SOURCE_CLIENT,
  TRACKER_ERROR_SOURCE_SERVER,
  TRACKER_MINI_WISHLIST_OVERLAY_OPEN,
  TRACKER_PRODS_DELETE,
} from '../constants/tracker'
import wcs from '../libs/wcs'
import { WcsCart } from '../libs/wcs/cart'

import { ACTION_OPEN_MINICART } from './actions/pdp'
import { SHOW_PANEL } from './footer'
import {
  HIDE_OVERLAY,
  HIDE_PICKUPSTORE,
  SHOW_PICKUPSTORE,
  UPDATE_GOOGLE_MAP_DATA,
  UPDATE_LAST_ADDTOBAG_ITEM,
  UPDATE_LAST_WISHLIST_ITEM,
  UPDATE_MINICART_DATA,
  UPDATE_MINIWISHLIST_DATA,
  UPDATE_NAVIGATION_MENU,
  UPDATE_NAVIGATION_PANEL,
  UPDATE_SIDEBAR_OVERLAY,
  UPDATE_UI_BODY,
  UPDATE_URL,
  UPDATE_NEWSLETTER_COUNTER,
  UPDATE_USER_DATA,
  SET_USER_SELF_DATA,
  UPDATE_NO_ECOMMERCE_COUNTER,
  OPEN_FIND_IN_STORE_PANEL,
  CLOSE_FIND_IN_STORE_PANEL,
  OPEN_STORE_DETAILS_PANEL,
  CLOSE_STORE_DETAILS_PANEL,
  OPEN_EYEMED_MODAL_OR_PANEL,
  CLOSE_EYEMED_MODAL_OR_PANEL,
  UPDATE_PDP_DASH_BUTTON_SMALL,
  CLOSE_AFTERPAY_MODAL_OR_PANEL,
  OPEN_AFTERPAY_MODAL_OR_PANEL,
  UPDATE_NEWSLETTER_OPEN_STATUS,
  LOCK_TRUST_PILOT_SCRIPT,
  SET_GOOGLE_MAPS_SCRIPTS_STATUS,
  SHOW_PAYMENT_MESSAGE_BOX,
  HIDE_PAYMENT_MESSAGE_BOX,
  UPDATE_KLARNA_EXPRESS_LOADED_STATUS,
  UPDATE_KLARNA_EXPRESS_INITIALIZED,
  UPDATE_ROX_PANEL_OVERLAY,
} from './mutations'

import WcsEyemed from '../libs/wcs/eyemed'
import { WcsWishlist } from '../libs/wcs/wishlist'
import { PhysicalStores } from '../libs/physical-stores/physical-stores'
import { WcsUser } from '../libs/wcs/user'
import { SizeAdvisor } from '@/scripts/libs/size-advisor'
import { FrameAdvisor } from '@/scripts/libs/frame-advisor'
import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'
import { ANONIMOUS_USER_CODE } from '../constants/user'
import { EarlyAccess } from '../libs/early-access'
import { WcsEarlyAccess } from '../libs/wcs/early-access'
import VirtualMirror from '@/scripts/libs/virtual-mirror/VirtualMirror'
import { WcsPromotions } from '@/scripts/libs/wcs/promotions'

const { storeId } = wcs.getStoreConfig()

const debug = makeDebug('store:action')

export const ACTION_LOAD_USER = 'ACTION_LOAD_USER'
export const ACTION_LOAD_MINICART = 'ACTION_LOAD_MINICART'
export const ACTION_LOAD_MINIWISHLIST = 'ACTION_LOAD_MINIWISHLIST'

export const ACTION_HIDE_NAVIGATION_MENU = 'ACTION_HIDE_NAVIGATION_MENU'

export const ACTION_HIDE_OVERLAY = 'ACTION_HIDE_OVERLAY'
export const ACTION_ADD_TO_WISHLIST = 'ACTION_ADD_TO_WISHLIST'
export const ACTION_REMOVE_FROM_WISHLIST = 'ACTION_REMOVE_FROM_WISHLIST'
export const ACTION_SHOW_WISHLIST = 'ACTION_SHOW_WISHLIST'
export const ERROR_ADD_TO_WISHLIST = 'ERROR_ADD_TO_WISHLIST'

export const ACTION_SHOW_CART = 'ACTION_SHOW_CART'
export const ACTION_HIDE_SIDEBAR = 'ACTION_HIDE_SIDEBAR'

export const ACTION_ADD_TO_BAG = 'ACTION_ADD_TO_BAG'
export const ACTION_ADD_TO_BAG_SYNC = 'ACTION_ADD_TO_BAG_SYNC'
export const ACTION_REMOVE_FROM_CART = 'ACTION_REMOVE_FROM_CART'
export const ERROR_ADD_TO_BAG = 'ERROR_ADD_TO_BAG'

export const ACTION_INCREMENT_NEWSLETTER_COUNTER = 'ACTION_INCREMENT_NEWSLETTER_COUNTER'

export const ACTION_INCREMENT_NO_ECOMMERCE_COUNTER = 'ACTION_INCREMENT_NO_ECOMMERCE_COUNTER'

export const ACTION_PDP_OPEN_FOOTER_CONTACT = 'ACTION_PDP_OPEN_FOOTER_CONTACT'

export const ACTION_ADD_TO_BAG_REMIX = 'ACTION_ADD_TO_BAG_REMIX'

export const ACTION_SHOW_PICKUPSTORE = 'ACTION_SHOW_PICKUPSTORE'
export const ACTION_HIDE_PICKUPSTORE = 'ACTION_HIDE_PICKUPSTORE'
export const ACTION_ADD_PRODUCT_AND_CORRELATED_TO_SHOPPING_BAG =
  'ACTION_ADD_PRODUCT_AND_CORRELATED_TO_SHOPPING_BAG'

export const ACTION_ADD_OPTICS_TO_BAG = 'ACTION_ADD_OPTICS_TO_BAG'

export const ACTION_ADD_BENEFITS_TO_BAG = 'ACTION_ADD_BENEFITS_TO_BAG'

export const ACTION_SAVE_USER_DATA = 'ACTION_SAVE_USER_DATA'
export const ACTION_UPDATE_GOOGLE_MAP_DATA = 'ACTION_UPDATE_GOOGLE_MAP_DATA'

export const ACTION_UPDATE_URL = 'ACTION_UPDATE_URL'

export const ACTION_OPEN_FIND_IN_STORE_PANEL = 'ACTION_OPEN_FIND_IN_STORE_PANEL'
export const ACTION_CLOSE_FIND_IN_STORE_PANEL = 'ACTION_CLOSE_FIND_IN_STORE_PANEL'

export const ACTION_OPEN_STORE_DETAILS_PANEL = 'ACTION_OPEN_STORE_DETAILS_PANEL'
export const ACTION_CLOSE_STORE_DETAILS_PANEL = 'ACTION_CLOSE_STORE_DETAILS_PANEL'

export const ACTION_OPEN_EYEMED_MODAL_OR_PANEL = 'ACTION_OPEN_EYEMED_MODAL_OR_PANEL'
export const ACTION_CLOSE_EYEMED_MODAL_OR_PANEL = 'ACTION_CLOSE_EYEMED_MODAL_OR_PANEL'

export const ACTION_UPDATE_DASH_BUTTON_SMALL = 'ACTION_UPDATE_DASH_BUTTON_SMALL'

export const ACTION_UPDATE_NEWSLETTER_OPEN_STATUS = 'ACTION_UPDATE_NEWSLETTER_OPEN_STATUS'
export const ACTION_OPEN_AFTERPAY_MODAL_OR_PANEL = 'ACTION_OPEN_AFTERPAY_MODAL_OR_PANEL'
export const ACTION_CLOSE_AFTERPAY_MODAL_OR_PANEL = 'ACTION_CLOSE_AFTERPAY_MODAL_OR_PANEL'

export const ACTION_LOCK_TRUST_PILOT_SCRIPT = 'ACTION_LOCK_TRUST_PILOT_SCRIPT'
export const ACTION_SET_GOOGLE_MAPS_SCRIPTS_STATUS = 'ACTION_SET_GOOGLE_MAPS_SCRIPTS_STATUS'
export const ACTION_LOAD_SELF_AND_MY_ACCOUNT = 'ACTION_LOAD_SELF_AND_MY_ACCOUNT'

export const ACTION_EVALUATE_EARLY_ACCESS = 'ACTION_EVALUATE_EARLY_ACCESS'
export const ACTION_EVALUATE_PROMO_CODE = 'ACTION_EVALUATE_PROMO_CODE'

export const ACTION_SET_PICKUP_STORE_TRUE = 'ACTION_SET_PICKUP_STORE_TRUE'

export const ACTION_SHOW_PAYMENT_MESSAGE_BOX = 'ACTION_SHOW_PAYMENT_MESSAGE_BOX'
export const ACTION_HIDE_PAYMENT_MESSAGE_BOX = 'ACTION_HIDE_PAYMENT_MESSAGE_BOX'

export const ACTION_SET_KLARNA_EXPRESS_LOADED_STATUS = 'ACTION_SET_KLARNA_EXPRESS_LOADED_STATUS'

export const ACTION_SET_KLARNA_EPXRESS_INITIALIZED = 'ACTION_SET_KLARNA_EPXRESS_INITIALIZED'

export const ACTION_UPDATE_ROX_PANEL_OVERLAY = 'ACTION_UPDATE_ROX_PANEL_OVERLAY'

export const actions = {
  [ACTION_LOAD_USER]: async function ({ commit }) {
    const user = await WcsUser.getUserData()
    commit(UPDATE_USER_DATA, user)
  },
  [ACTION_LOAD_MINICART]: async function ({ commit }) {
    debug(ACTION_LOAD_MINICART)

    commit(UPDATE_MINICART_DATA, { loading: true })

    try {
      let result = ''
      const isCsrSession = !!Cookies.get(IS_CSR)
      if (
        Cookies.get(CART_SAVED) &&
        !CART_CALL_PAGES_NEEDED.includes(window.wcs_config.viewTaskName) &&
        !isCsrSession
      ) {
        result = JSON.parse(localStorage.getItem(CART_SAVED))
        if (isEmpty(result)) {
          result = await WcsCart.getMinicart()
        }
      } else {
        result = await WcsCart.getMinicart()
      }

      debug('wcs_get_minicart result %o', result)

      const orderItems = get(result, 'orderItem', {})

      const promotionDetails = get(result, 'promotionDetails', {})

      const raybanUkDetails = get(result, 'RayBan_UK', [])

      let quantity = 0
      const items = get(result, 'orderDetails.items', []).map((item) => {
        quantity += Number(item.orderItemCount)
        return {
          ...item,
          ...orderItems[item.orderItemId],
          preorderLabelText: result.preorderLabelText,
        }
      })

      const orderDetails = get(result, 'orderDetails', {
        TotalAdjustment: '0',
        TotalShipping: '0',
        Subtotal: '0',
        isCartMerged: false,
        TotalTax: 0,
        GrandTotal: '',
        prescriptionItemPresentInOrder: false,
        TotalAmount: 0,
      })

      const payload = {
        loading: false,
        quantity,
        items: orderBy(items, 'displayOrder'),
        details: {
          orderId: orderDetails.orderId,
          subTotal: Number(orderDetails.Subtotal),
          shippingCost: Number(orderDetails.TotalShipping),
          adjustment: Number(orderDetails.TotalAdjustment),
          tax: orderDetails.TotalTax,
          total: orderDetails.GrandTotal,
          totalToNumber: Number(orderDetails.TotalAmount),
          prescriptionItemPresentInOrder: orderDetails.prescriptionItemPresentInOrder,
        },
        promotionDetails: {
          ...promotionDetails,
        },
        raybanUkDetails,
      }

      commit(UPDATE_MINICART_DATA, payload)

      return payload
    } catch (error) {
      debug('error wcs_get_minicart %o', error)
      this._vm.$ma.trackException({ source: TRACKER_ERROR_SOURCE_CLIENT, code: error.message })
    }
  },

  [ACTION_LOAD_MINIWISHLIST]: async function ({ commit }) {
    debug(ACTION_LOAD_MINIWISHLIST)

    commit(UPDATE_MINIWISHLIST_DATA, { loading: true })

    try {
      let result = ''

      if (Cookies.get(MINIWISHLIST_SAVED)) {
        result = JSON.parse(sessionStorage.getItem(MINIWISHLIST_SAVED))
      }

      if (!result) {
        result = await WcsWishlist.get()
      }

      debug('WcsWishlist.get result %o', result)

      result.map((wishlist) => {
        const quantity = Number(get(wishlist, 'totalItemsCount'))
        const wishlistItems = get(wishlist, 'items', {}).map((item) => {
          item.image = item.image?.replaceAll('&amp;', '&')
          return {
            ...item,
            ...wishlistItems,
          }
        })
        const payload = {
          loading: false,
          quantity,
          items: orderBy(wishlistItems, 'displayOrder'),
          details: {
            wishListHeader: get(wishlist, 'wishListHeader'),
            wishlistId: get(wishlist, 'wishListId'),
          },
        }

        commit(UPDATE_MINIWISHLIST_DATA, payload)
      })
    } catch (error) {
      debug('error WcsWishlist.get %o', error)
      this._vm.$ma.trackException({ source: TRACKER_ERROR_SOURCE_CLIENT, code: error.message })
    }
  },
  [ACTION_HIDE_OVERLAY]: function ({ commit, dispatch }) {
    commit(HIDE_OVERLAY)
    commit(UPDATE_NAVIGATION_PANEL, false)
    dispatch(ACTION_HIDE_NAVIGATION_MENU)
  },
  [ACTION_HIDE_NAVIGATION_MENU]: function (
    { commit },
    payload = { menuId: null, currentTitle: '' }
  ) {
    commit(UPDATE_NAVIGATION_MENU, payload)
  },
  [ACTION_SHOW_WISHLIST]: function ({ commit, state }) {
    const { wishlist, cart } = state.sidebar
    const isVtoSupportedBrowser = VirtualMirror.isSupportedByBrowser() ? ONE : ZERO
    let ObjProducts = {}
    cart.show = false
    wishlist.show = !wishlist.show
    wishlist.loading = false
    commit(UPDATE_SIDEBAR_OVERLAY, { show: wishlist.show, wishlist: wishlist, cart: cart })
    commit(UPDATE_UI_BODY, {
      overflow: wishlist.show ? 'hidden' : 'unset',
      position: wishlist.show ? 'absolute' : '',
      height: wishlist.show ? '100%' : '',
    })
    for (let i = 0; i < wishlist.items.length; i++) {
      const type =
        wishlist.items[i].isRemix === 'true'
          ? 'CP'
          : wishlist.items[i].isPrescription === 'true'
          ? RX
          : STD
      const partNumber = wishlist.items[i]?.partnumber
      ObjProducts[partNumber] = {
        Status: wishlist.items[i].status,
        OosOptions: wishlist.items[i].oosOptions,
        Conf_IsUpcSupported: ONE,
        Category: wishlist.items[i].category,
        FrameType: type,
        Engraving: '',
        Price: (wishlist.items[i].price && wishlist.items[i].price.offer) || '',
        PriceFull: (wishlist.items[i].price && wishlist.items[i].price.offer) || '',
        Brand: RB,
        Size: wishlist.items[i].modelSize,
        Sku: wishlist.items[i].modelName,
        ModelName: wishlist.items[i].name,
        MoCo: '',
        Stock: wishlist.items[i].stock,
        Image: wishlist.items[i].image,
        Url: wishlist.items[i].pdpURL,
        LensColor: (wishlist.items[i].lenses && wishlist.items[i].lenses.value) || '',
        LensTechnology: '',
        FrameColor: (wishlist.items[i].frame && wishlist.items[i].frame.value) || '',
        FrameTechnology: wishlist.items[i].frameMaterial,
        Shape: wishlist.items[i].frameShape,
      }
    }
    this._vm.$ma.trackEvent({
      event: TRACKER_MINI_WISHLIST_OVERLAY_OPEN,
      value: {
        Vm_IsBrowserSupported: isVtoSupportedBrowser,
        Products: ObjProducts,
      },
    })
  },
  // eslint-disable-next-line no-unused-vars
  [ACTION_ADD_TO_WISHLIST]: async function (
    { commit, dispatch, state },
    { catEntry, mq, upcLensRox }
  ) {
    try {
      const response = await WcsWishlist.addProduct({
        catEntry,
      })

      const catEntryId = catEntry.catEntryId_1 ? catEntry.catEntryId_1 : catEntry
      commit(UPDATE_LAST_WISHLIST_ITEM, { catEntry: catEntryId })
      if (response.errorCode) {
        this._vm.$ma.trackException({
          source: TRACKER_ERROR_SOURCE_SERVER,
          code: response.errorCode,
          detail: response.errorMessage,
        })
        return
      }

      Cookies.remove(MINIWISHLIST_SAVED)
      await dispatch(ACTION_LOAD_MINIWISHLIST)

      // APPLY THIS PART OF CODE ONLY WHEN IS MOBILE
      if (mq === MOBILE || mq === TABLET) {
        const { wishlist } = state.sidebar
        wishlist.show = !wishlist.show
        commit(UPDATE_SIDEBAR_OVERLAY, { show: wishlist.show, wishlist: wishlist })
        commit(UPDATE_UI_BODY, {
          overflow: wishlist.show ? 'hidden' : 'unset',
        })
        setTimeout(() => {
          wishlist.show = false
          commit(UPDATE_SIDEBAR_OVERLAY, { show: wishlist.show, wishlist: wishlist })
          commit(UPDATE_UI_BODY, {
            overflow: wishlist.show ? 'hidden' : 'unset',
          })
        }, 3000)
      }
    } catch (e) {
      dispatch(ERROR_ADD_TO_WISHLIST, e)
    }

    const product = state.pdp.correlatedProducts[catEntry]
    const type = upcLensRox ? RX : STD
    this._vm.$ma.trackEvent({
      event: TRACKER_ADDTOWISHLIST,
      value: {
        Products: {
          [product?.partNumber]: {
            Category: product?.type?.toUpperCase(),
            FrameType: type,
          },
        },
      },
    })
  },
  [ACTION_REMOVE_FROM_WISHLIST]: async function (
    { commit, dispatch, state },
    { wishlistItemId, roxSet, configurationId }
  ) {
    debug(ACTION_REMOVE_FROM_WISHLIST)

    commit(UPDATE_MINIWISHLIST_DATA, { loading: true })

    try {
      const wishlistId = get(state, 'sidebar.wishlist.details.wishlistId', null)

      if (!wishlistId) {
        throw new Error('wishlistId is null')
      }

      debug('remove product %s from wishlist %s', wishlistItemId, wishlistId)

      const response = await WcsWishlist.removeProduct({
        wishlistItemId,
        wishlistId,
        roxSet,
        configurationId,
      })

      if (response.errorCode) {
        this._vm.$ma.trackException({
          source: TRACKER_ERROR_SOURCE_SERVER,
          code: response.errorCode,
          detail: response.errorMessage,
        })
        return
      }
      Cookies.remove(MINIWISHLIST_SAVED)
      await dispatch(ACTION_LOAD_MINIWISHLIST)
    } catch (error) {
      this._vm.$ma.trackException({ source: TRACKER_ERROR_SOURCE_CLIENT, code: error.message })
    }
  },
  [ERROR_ADD_TO_WISHLIST]: function (store, error) {
    this._vm.$ma.trackException({ source: TRACKER_ERROR_SOURCE_CLIENT, code: error.message })
  },
  [ACTION_SHOW_CART]: function (
    { commit, state, dispatch },
    { isMobile = false, isPickupStore = false }
  ) {
    let { cart, wishlist } = state.sidebar
    let ObjProducts = {}
    wishlist.show = false
    cart.isPickupStore = isPickupStore

    // TODO: do we have to do this only on mobile?
    cart.show = false

    if (isMobile) {
      commit(UPDATE_SIDEBAR_OVERLAY, { show: false, cart: cart, wishlist: wishlist })
      dispatch(`pdp/${ACTION_OPEN_MINICART}`)
      commit(UPDATE_UI_BODY, {
        overflow: cart.show ? 'hidden' : 'unset',
        position: cart.show ? 'absolute' : '',
        height: cart.show ? '100%' : '',
      })
    } else {
      dispatch(`pdp/${ACTION_OPEN_MINICART}`)
    }

    cart.items.forEach((item) => {
      const product = item
      const isRemixable = product.remixable === REMIXABLE ? ONE : '0'
      const priceDiscounted = product.orderItemOfferPrice
        ? parseFloat(product.orderItemOfferPrice).toFixed(2).toString()
        : parseFloat(product.orderItemPrice).toFixed(2).toString()
      ObjProducts[product.partNumber] = {
        Status: product.status,
        OosOptions: product.oosOptions,
        Conf_IsUpcSupported: isRemixable,
        Category: product.producttype,
        FrameType: product.type,
        Price: priceDiscounted,
        PriceFull: parseFloat(product.orderItemPrice).toFixed(2).toString(),
        Brand: RB,
        Size: product.modelSize,
        Sku: product.displaySKU,
        ModelName: product.name,
        MoCo: product.modelNo,
        Stock: parseFloat(product.inventoryOfItem).toString(),
        Image: product.image,
        Url: product.pdpUrl,
        LensColor: product.lensColor,
        LensTechnology: '',
        FrameColor: product.frameShape,
        FrameTechnology: product.frameMaterial,
        Shape: product.frameShape,
        LensUPC: '',
      }
    })
  },
  // TODO: check if this is still needed
  [ACTION_HIDE_SIDEBAR]: function ({ commit, state }) {
    const { cart, wishlist } = state.sidebar
    wishlist.show = false
    cart.show = false
    commit(UPDATE_SIDEBAR_OVERLAY, { show: false, cart: cart, wishlist: wishlist })
    commit(UPDATE_UI_BODY, {
      overflow: cart.show ? 'hidden' : 'unset',
      position: cart.show ? 'absolute' : '',
      height: cart.show ? '100%' : '',
    })
  },
  [ACTION_ADD_TO_BAG_SYNC]: function (
    { dispatch, commit, state, getters },
    { catEntry, upcLensRox, parameters }
  ) {
    try {
      const response = WcsCart.addProductSync({
        catEntry,
        parameters,
      })
      let orderItemId =
        response.orderItemId && response.orderItemId[response.orderItemId.length - 1]

      if (!orderItemId) {
        const cat = response.catEntryId[0]
        const itemFromCart = get(state, 'sidebar.cart.items', [])
        orderItemId = itemFromCart.find(
          (item) => item.catentryId === cat && item.type !== 'RX'
        ).orderItemId
      }

      commit(UPDATE_LAST_ADDTOBAG_ITEM, { orderItemId: orderItemId })

      if (response.errorCode) {
        this._vm.$ma.trackException({
          source: TRACKER_ERROR_SOURCE_SERVER,
          code: response.errorCode,
          detail: response.errorMessage,
        })
        return
      }

      const product = state.pdp.correlatedProducts[catEntry]
      const selectedProductAvailability = getters.selectedProductAvailability
        ? getters.selectedProductAvailability
        : getters['pdp/selectedProductAvailability']

      this._vm.$ma.trackEvent({
        event: TRACKER_ADDTOCART,
        value: {
          Products: {
            [product.partNumber]: {
              Status: getProductStatusAnalytics(selectedProductAvailability, product),
              Category: product?.type?.toUpperCase(),
              FrameType: ALL_ELECTRONICS_PRODUCT_TYPES.includes(product?.type)
                ? product?.type?.toUpperCase()
                : STD,
              Price: product?.prices?.listPrice,
              PriceFull: product?.prices?.listPrice,
              Brand: RB,
              Size:
                product?.sizes &&
                product?.sizes.length &&
                product?.sizes.find((size) => size.catEntryId === catEntry)?.label,
              Sku: product?.resolvedSkuGridLensBridgeVal,
              ModelName: product?.modelName,
              MoCo: '',
              Stock: selectedProductAvailability?.inventory,
              Image: product?.imageUrl,
              Url: product?.pageUrl,
              LensColor: product.features?.lenses?.color,
              LensTechnology: '',
              FrameColor: product.features?.frame?.color,
              FrameTechnology: product?.features?.frame?.materialPrimary,
              Shape: product?.features?.frame?.shape,
              LensUPC: upcLensRox ? upcLensRox.partNumber : '',
              ModelCode: '',
              Lens: '',
              Frame: '',
              Case: '',
              Cloth: '',
              Units: ONE,
              Preorder: product.isPreOrder ? '1' : '0',
              Visibility: product.isSemiPrivateSale ? IS_SEMIPRIVATE : PUBLIC,
            },
          },
        },
      })

      Cookies.remove(CART_SAVED)
      dispatch(ACTION_LOAD_MINICART)
      dispatch(ACTION_SHOW_CART)
    } catch (e) {
      dispatch(ERROR_ADD_TO_BAG, e)
    }
  },
  [ACTION_ADD_TO_BAG]: async function (
    { dispatch, commit, state, getters },
    {
      catEntry,
      upcLensRox,
      parameters,
      isFromWishlist,
      redirect = false,
      bypassAnalytics = false,
      isPickupStore = false,
      isMobile = false,
      configurationId,
      isFromMinicart = false,
      MinicartProduct,
    }
  ) {
    try {
      if (configurationId) {
        parameters = []
        const roxSetArray = configurationId.split('_')
        roxSetArray?.forEach((roxElement, i) => {
          parameters['catEntryId_' + (i + 1)] = roxElement
          parameters['quantity_' + (i + 1)] = 1
        })
        parameters.roxSet_1 = configurationId
      }

      const response = await WcsCart.addProduct({
        catEntry,
        isPickupStore,
        parameters,
      })

      let orderItemId =
        response.orderItemId && response.orderItemId[response.orderItemId.length - 1]

      if (!orderItemId) {
        const cat = response.catEntryId[0]
        const itemFromCart = get(state, 'sidebar.cart.items', [])
        orderItemId = itemFromCart.find(
          (item) => item.catentryId === cat && item.type !== 'RX'
        ).orderItemId
      }

      commit(UPDATE_LAST_ADDTOBAG_ITEM, { orderItemId: orderItemId })

      if (response.errorCode) {
        this._vm.$ma.trackException({
          source: TRACKER_ERROR_SOURCE_SERVER,
          code: response.errorCode,
          detail: response.errorMessage,
        })
        return
      }
      if (isFromMinicart) {
        const product = MinicartProduct
        AlgoliaAnalytics.setProductsQueryID(product?.partNumber)
        let currentPromotion = {}
        const priceWithNoPromo =
          product.category === 'KIT' ? product.colors[0]?.price : product.originalPrice

        const parsedPrice = parseFloat(
          priceWithNoPromo?.replace(',', '.')?.replace(/[^\d.-]/g, '')
        ).toFixed(2)

        if (product.promotions) {
          currentPromotion = WcsPromotions.calculatePromotionInProgress(product.promotions)
        }
        const price =
          parseFloat(
            Object.keys(currentPromotion).length > 0
              ? parseFloat(currentPromotion.price).toFixed(2)
              : WcsCart.getPrice(product, upcLensRox)
          ) ||
          priceWithNoPromo ||
          parsedPrice
        const priceFull =
          parseFloat(WcsCart.getFullPrice(product, upcLensRox)) || priceWithNoPromo || parsedPrice
        let Sg_BestMatchVal = 0
        if (product.sizes) {
          const analysisResults =
            FrameAdvisor.getAnalysisResults() || state.frameGenius?.analysisResults
          const suggestedSizes = SizeAdvisor.mapSuggestedSizes(product.sizes, analysisResults)
          const currentSize = product.sizes.find((size) => size.catEntryId === catEntry)
          const valueArr = [
            SizeAdvisor.isSizeRecommended(currentSize, suggestedSizes),
            SizeAdvisor.isSizeNextBestSize(currentSize, suggestedSizes),
            SizeAdvisor.isSizeTooLoose(currentSize, suggestedSizes),
          ]
          valueArr.forEach((val, index) => {
            if (val) {
              Sg_BestMatchVal = index + 1
            }
          })
        }
        const selectedProductAvailability = getters.selectedProductAvailability
          ? getters.selectedProductAvailability
          : getters['pdp/selectedProductAvailability']
        if (!bypassAnalytics) {
          this._vm.$ma.trackEvent({
            event: TRACKER_ADDTOCART,
            value: {
              Products: {
                [product?.partNumber]: {
                  Status: getProductStatusAnalytics(selectedProductAvailability, product),
                  Category: product?.type?.toUpperCase(),
                  FrameType: product?.type?.toUpperCase(),
                  Price: price.toString(), //prezzo scontato
                  PriceFull: priceFull.toString(), //prezzo base
                  Brand: RB,
                  Size:
                    product?.sizes &&
                    product?.sizes.length &&
                    product?.sizes.find((size) => size.catEntryId === catEntry)?.label,
                  Sku: product?.resolvedSkuGridLensBridgeVal,
                  ModelName: product?.modelName,
                  MoCo: product?.moCo,
                  Stock: selectedProductAvailability?.inventory,
                  Image: product?.productImage,
                  Url: product?.pdpUrl,
                  LensColor: '',
                  LensTechnology: '',
                  FrameColor: '',
                  FrameTechnology: '',
                  Shape: '',
                  ModelCode: '',
                  Lens: '',
                  Frame: '',
                  Units: ONE,
                  Preorder: product.isPreOrder ? '1' : '0',
                  Visibility: product.isSemiPrivateSale ? IS_SEMIPRIVATE : PUBLIC,
                },
              },
            },
          })
        }
      }

      if (isFromWishlist) {
        const { wishlist } = state.sidebar
        const productFromWishlist = wishlist.items.find((v) => v.catentryId === catEntry)
        const type =
          productFromWishlist.isRemix === 'true'
            ? 'CP'
            : productFromWishlist.isPrescription === 'true'
            ? RX
            : STD

        AlgoliaAnalytics.setProductsQueryID(productFromWishlist?.partNumber)
        this._vm.$ma.trackEvent({
          event: TRACKER_ADDTOCART,
          value: {
            Products: {
              [productFromWishlist.partnumber]: {
                Status: productFromWishlist.isPreOrder
                  ? PREORDER_AVAILABLE_ANALYTICS
                  : productFromWishlist.status,
                OosOptions: productFromWishlist.oosOptions,
                Conf_IsUpcSupported: ONE,
                Category: productFromWishlist.category,
                FrameType: type,
                Engraving: '',
                Price: (productFromWishlist.price && productFromWishlist.price.offer) || '',
                PriceFull: (productFromWishlist.price && productFromWishlist.price.offer) || '',
                Brand: RB,
                Size: productFromWishlist.modelSize,
                Sku: productFromWishlist.modelName,
                ModelName: productFromWishlist.name,
                MoCo: '',
                Stock: productFromWishlist.stock,
                Image: productFromWishlist.image,
                Url: productFromWishlist.pdpURL,
                LensColor: (productFromWishlist.lenses && productFromWishlist.lenses.value) || '',
                LensTechnology: '',
                FrameColor: (productFromWishlist.frame && productFromWishlist.frame.value) || '',
                FrameTechnology: productFromWishlist.frameMaterial,
                Shape: productFromWishlist.frameShape,
                Units: ONE,
                Preorder: productFromWishlist.isPreOrder ? '1' : '0',
                Visibility: productFromWishlist.isSemiPrivateSale ? IS_SEMIPRIVATE : PUBLIC,
              },
            },
          },
        })
      } else {
        const product = state.pdp.correlatedProducts[catEntry]
        const type = upcLensRox ? RX : STD
        if (product) {
          AlgoliaAnalytics.setProductsQueryID(product?.partNumber)
          let currentPromotion = {}
          if (product.promotions) {
            currentPromotion = WcsPromotions.calculatePromotionInProgress(product.promotions)
          }
          const price =
            Object.keys(currentPromotion).length > 0
              ? parseFloat(currentPromotion.price).toFixed(2)
              : WcsCart.getPrice(product, upcLensRox)
          const priceFull = WcsCart.getFullPrice(product, upcLensRox)
          let Sg_BestMatchVal = 0
          if (product.sizes) {
            const analysisResults =
              FrameAdvisor.getAnalysisResults() || state.frameGenius?.analysisResults
            const suggestedSizes = SizeAdvisor.mapSuggestedSizes(product.sizes, analysisResults)
            const currentSize = product.sizes.find((size) => size.catEntryId === catEntry)
            const valueArr = [
              SizeAdvisor.isSizeRecommended(currentSize, suggestedSizes),
              SizeAdvisor.isSizeNextBestSize(currentSize, suggestedSizes),
              SizeAdvisor.isSizeTooLoose(currentSize, suggestedSizes),
            ]
            valueArr.forEach((val, index) => {
              if (val) {
                Sg_BestMatchVal = index + 1
              }
            })
          }
          const selectedProductAvailability = getters.selectedProductAvailability
            ? getters.selectedProductAvailability
            : getters['pdp/selectedProductAvailability']
          if (!bypassAnalytics) {
            const event = {
              event: TRACKER_ADDTOCART,
              value: {
                Products: {
                  [product?.partNumber]: {
                    Status: getProductStatusAnalytics(selectedProductAvailability, product),
                    Category: product?.type?.toUpperCase(),
                    FrameType: type,
                    Price: price.toString(), //prezzo scontato
                    PriceFull: priceFull.toString(), //prezzo base
                    Brand: RB,
                    Size:
                      product?.sizes &&
                      product?.sizes.length &&
                      product?.sizes.find((size) => size.catEntryId === catEntry)?.label,
                    Sku: product?.resolvedSkuGridLensBridgeVal,
                    ModelName: product?.modelName,
                    MoCo: product?.catEntryId,
                    Stock: selectedProductAvailability?.inventory,
                    Image: product?.imageUrl,
                    Url: product?.pageUrl,
                    LensColor: product?.features?.lenses?.color,
                    LensTechnology: product?.features?.lenses?.description,
                    FrameColor: product?.features?.frame?.color,
                    FrameTechnology: product?.features?.frame?.materialPrimary,
                    Shape: product?.features?.frame?.shape,
                    LensUPC: upcLensRox ? upcLensRox.partNumber : '',
                    ModelCode: '',
                    Lens: '',
                    Frame: '',
                    Case: '',
                    Cloth: '',
                    Units: ONE,
                    Sg_BestMatch: Sg_BestMatchVal,
                    Preorder: product.isPreOrder ? '1' : '0',
                    Visibility: product.isSemiPrivateSale ? IS_SEMIPRIVATE : PUBLIC,
                  },
                },
              },
            }

            this._vm.$ma.trackEvent(event)
          }
        }
      }
      Cookies.remove(CART_SAVED)
      const cart = await dispatch(ACTION_LOAD_MINICART)

      dispatch(ACTION_SHOW_CART, { isMobile, isPickupStore })

      if (state.pdp.eyeMed.applied) {
        const postParams = {
          pageTypeIns: 'CartPage',
          isBenefitPricingRequired: true,
          isCalculateViewRequired: true,
        }
        await WcsEyemed.makeBenefitPricingCall(postParams)
      }

      const selectedCEP = sessionStorage.getItem('selectedCEP')
      if (storeId === WcsStoreId.BRAZIL && selectedCEP) {
        await WcsCart.brazilCallStack({
          postalCode: selectedCEP.replace(/-/g, ''),
          storeId,
          orderId: get(state, 'sidebar.cart.details.orderId', null),
        })
      }

      if (redirect) {
        window.location.href = wcs.getEndPoint('shopCartView')
      }

      if (isFromWishlist && !wcs.isInPdp()) {
        const { wishlist } = state.sidebar
        const itemLength = wishlist.items.length
        if (itemLength === 1) {
          dispatch(ACTION_HIDE_SIDEBAR)
        } else {
          await dispatch(ACTION_LOAD_MINIWISHLIST)
          dispatch(ACTION_SHOW_WISHLIST)
        }
      }

      return { response, cart }
    } catch (e) {
      dispatch(ERROR_ADD_TO_BAG, e)
    }
  },
  [ACTION_ADD_TO_BAG_REMIX]: async function (
    { dispatch, state },
    { catEntry, configurationId, isFromWishlist }
  ) {
    const parameters = {
      URL: WISHLIST_VIEW,
      roxlensAndServiceSet: '',
      field1: '',
      orderId: '.',
      xdkInterestItem_Id: '',
      configurationId: configurationId,
      doInventory: N,
      calculateOrder: ONE,
      calculationUsage: '-1, -3',
      catEntryId: catEntry,
      quantity: 1,
    }

    try {
      const response = await WcsCart.addRemixProduct({ parameters })

      if (response.errorCode) {
        this._vm.$ma.trackException({
          source: TRACKER_ERROR_SOURCE_SERVER,
          code: response.errorCode,
          detail: response.errorMessage,
        })
        return
      }
      Cookies.remove(CART_SAVED)
      dispatch(ACTION_LOAD_MINICART)
      dispatch(ACTION_SHOW_CART)

      const selectedCEP = sessionStorage.getItem('selectedCEP')
      if (storeId === WcsStoreId.BRAZIL && selectedCEP) {
        await WcsCart.brazilCallStack({
          postalCode: selectedCEP.replace(/-/g, ''),
          storeId,
          orderId: get(state, 'sidebar.cart.details.orderId', null),
        })
      }

      if (isFromWishlist && !wcs.isInPdp()) {
        const { wishlist } = state.sidebar
        const itemLength = wishlist.items.length
        if (itemLength === 1) {
          dispatch(ACTION_HIDE_SIDEBAR)
        } else {
          await dispatch(ACTION_LOAD_MINIWISHLIST)
          dispatch(ACTION_SHOW_WISHLIST)
        }
      }
    } catch (e) {
      dispatch(ERROR_ADD_TO_BAG, e)
    }
  },
  [ERROR_ADD_TO_BAG]: function (store, error) {
    this._vm.$ma.trackException({ source: TRACKER_ERROR_SOURCE_CLIENT, code: error.message })
  },
  [ACTION_REMOVE_FROM_CART]: async function ({ state, dispatch, commit }, orderItemId) {
    debug(ACTION_REMOVE_FROM_CART)

    commit(UPDATE_MINICART_DATA, { loading: true })

    try {
      const orderId = get(state, 'sidebar.cart.details.orderId', null)

      if (!orderId) {
        throw new Error('orderId is null')
      }

      debug('remove product %s from order %s', orderItemId, orderId)

      const response = await WcsCart.removeProduct({
        orderItemId,
        orderId,
      })

      if (response.errorCode) {
        this._vm.$ma.trackException({
          source: TRACKER_ERROR_SOURCE_SERVER,
          code: response.errorCode,
          detail: response.errorMessage,
        })
        return
      }
      Cookies.remove(CART_SAVED)
      dispatch(ACTION_LOAD_MINICART)

      const cartItems = get(state, 'sidebar.cart.items', [])
      const productToRemove = cartItems.find((cartItem) => cartItem.orderItemId === orderItemId)
      const productCat =
        productToRemove.producttype === OPTICAL ? 'OPTICS' : productToRemove.producttype

      this._vm.$ma.trackEvent({
        event: TRACKER_PRODS_DELETE,
        value: {
          Products: {
            [productToRemove.partNumber]: {
              Category: productCat,
              FrameType: productToRemove.type,
              Sku: productToRemove.displaySKU,
            },
          },
        },
      })

      const keyRaybanPickup = PhysicalStores.getPickupStoreKey()
      const objPickupstore = JSON.parse(localStorage.getItem(keyRaybanPickup))
      if (objPickupstore.selected === true) {
        if (objPickupstore.idProduct === productToRemove.catentryId) {
          localStorage.removeItem(keyRaybanPickup)
        }
      }
    } catch (error) {
      this._vm.$ma.trackException({ source: TRACKER_ERROR_SOURCE_CLIENT, code: error.message })
    }
  },
  [ACTION_INCREMENT_NEWSLETTER_COUNTER]: function ({ commit }) {
    debug(ACTION_INCREMENT_NEWSLETTER_COUNTER)
    commit(UPDATE_NEWSLETTER_COUNTER)
  },
  [ACTION_INCREMENT_NO_ECOMMERCE_COUNTER]: function ({ commit }) {
    debug(ACTION_INCREMENT_NO_ECOMMERCE_COUNTER)
    commit(UPDATE_NO_ECOMMERCE_COUNTER)
  },
  [ACTION_PDP_OPEN_FOOTER_CONTACT]: function ({ commit }) {
    commit(SHOW_PANEL, 'contact')
  },
  [ACTION_SHOW_PICKUPSTORE]: function ({ commit }) {
    commit(SHOW_PICKUPSTORE)
  },
  [ACTION_HIDE_PICKUPSTORE]: function ({ commit }) {
    commit(HIDE_PICKUPSTORE)
  },
  [ACTION_ADD_PRODUCT_AND_CORRELATED_TO_SHOPPING_BAG]: async function (
    { dispatch },
    {
      selectedProduct,
      selectedRoxOpticLens,
      isEyeMedApplied = false,
      benefits = {},
      isPickupStore = false,
      isMobile = false,
    }
  ) {
    if (isPickupStore) {
      dispatch(ACTION_SET_PICKUP_STORE_TRUE)
    }
    if (
      isProductOpticalOrSun(selectedProduct.type) &&
      selectedProduct.roxFrameCatEntryId &&
      selectedRoxOpticLens &&
      isEyeMedApplied &&
      benefits
    ) {
      return await dispatch(ACTION_ADD_BENEFITS_TO_BAG, {
        selectedProduct,
        selectedRoxOpticLens,
        benefits,
        isPickupStore,
        isMobile,
      })
    } else if (
      (isProductOpticalOrSun(selectedProduct.type) ||
        isProductStellaByProductType(selectedProduct.type)) &&
      selectedProduct.roxFrameCatEntryId &&
      selectedRoxOpticLens?.mandatoryServicesList
    ) {
      return await dispatch(ACTION_ADD_OPTICS_TO_BAG, {
        selectedProduct,
        selectedRoxOpticLens,
        isPickupStore,
        isMobile,
      })
    } else {
      return await dispatch(ACTION_ADD_TO_BAG, {
        catEntry: selectedProduct.catEntryId,
        isPickupStore,
        isMobile,
      })
    }
  },
  [ACTION_ADD_OPTICS_TO_BAG]: async function (
    { dispatch },
    {
      selectedProduct,
      selectedRoxOpticLens,
      isPickupStore,
      isMobile,
      roxProductImage,
      roxFallbackImage,
      eyewearProtectionId = '',
    }
  ) {
    const params = prepareParamsForAddToBag(
      selectedProduct.roxFrameCatEntryId,
      selectedRoxOpticLens.catEntryId,
      selectedRoxOpticLens.mandatoryServicesList.join(','),
      isPickupStore,
      eyewearProtectionId
    )
    if (roxProductImage) {
      params.roxProductImage = roxProductImage
    }
    if (roxFallbackImage) {
      params.roxFallbackImage = roxFallbackImage
    }

    return await dispatch(ACTION_ADD_TO_BAG, {
      catEntry: selectedProduct.catEntryId,
      upcLensRox: selectedRoxOpticLens,
      parameters: params,
      isMobile,
    })
  },
  [ACTION_ADD_BENEFITS_TO_BAG]: async function (
    { dispatch },
    { selectedProduct, selectedRoxOpticLens, benefits, isPickupStore, isMobile }
  ) {
    const params = prepareParamsForAddToBag(
      benefits.roxFrameCatentryId[0],
      benefits.roxLensCatentryId[0],
      selectedRoxOpticLens.mandatoryServicesList.join(','),
      isPickupStore,
      ''
    )
    return await dispatch(ACTION_ADD_TO_BAG, {
      catEntry: selectedProduct.roxFrameCatEntryId,
      upcLensRox: selectedRoxOpticLens,
      parameters: params,
      isMobile,
    })
  },
  [ACTION_SAVE_USER_DATA]: async function ({ commit }, { userData }) {
    commit(SET_USER_SELF_DATA, userData)
  },
  [ACTION_UPDATE_GOOGLE_MAP_DATA]: function ({ commit }, payload) {
    debug(ACTION_UPDATE_GOOGLE_MAP_DATA)
    commit(UPDATE_GOOGLE_MAP_DATA, payload)
  },
  [ACTION_UPDATE_URL]: function ({ commit }, payload) {
    commit(UPDATE_URL, payload, { root: true })
  },

  [ACTION_OPEN_FIND_IN_STORE_PANEL]: function ({ commit }) {
    commit(OPEN_FIND_IN_STORE_PANEL)
  },
  [ACTION_CLOSE_FIND_IN_STORE_PANEL]: function ({ commit }) {
    commit(CLOSE_FIND_IN_STORE_PANEL)
  },
  [ACTION_OPEN_STORE_DETAILS_PANEL]: function ({ commit }) {
    commit(OPEN_STORE_DETAILS_PANEL)
  },
  [ACTION_CLOSE_STORE_DETAILS_PANEL]: function ({ commit }) {
    commit(CLOSE_STORE_DETAILS_PANEL)
  },
  [ACTION_OPEN_EYEMED_MODAL_OR_PANEL]: function ({ commit }) {
    commit(OPEN_EYEMED_MODAL_OR_PANEL)
  },
  [ACTION_CLOSE_EYEMED_MODAL_OR_PANEL]: function ({ commit }) {
    commit(CLOSE_EYEMED_MODAL_OR_PANEL)
  },
  [ACTION_UPDATE_DASH_BUTTON_SMALL]: function ({ commit }, payload) {
    commit(UPDATE_PDP_DASH_BUTTON_SMALL, payload)
  },
  [ACTION_OPEN_AFTERPAY_MODAL_OR_PANEL]: function ({ commit }) {
    commit(OPEN_AFTERPAY_MODAL_OR_PANEL)
  },
  [ACTION_CLOSE_AFTERPAY_MODAL_OR_PANEL]: function ({ commit }) {
    commit(CLOSE_AFTERPAY_MODAL_OR_PANEL)
  },
  [ACTION_UPDATE_NEWSLETTER_OPEN_STATUS]: function ({ commit }, payload) {
    commit(UPDATE_NEWSLETTER_OPEN_STATUS, payload)
  },
  [ACTION_LOCK_TRUST_PILOT_SCRIPT]: function ({ commit }) {
    commit(LOCK_TRUST_PILOT_SCRIPT)
  },
  [ACTION_SET_GOOGLE_MAPS_SCRIPTS_STATUS]: function ({ commit }) {
    commit(SET_GOOGLE_MAPS_SCRIPTS_STATUS)
  },
  [ACTION_SET_PICKUP_STORE_TRUE]: async function ({ commit }) {
    commit(ACTION_SET_PICKUP_STORE_TRUE)
  },
  [ACTION_LOAD_SELF_AND_MY_ACCOUNT]: async function ({ dispatch }) {
    const loadSelfAndMyAccount = async (WCSessionEstablished) => {
      if (WCSessionEstablished) {
        const { data } = await axios.get(wcs.getEndPoint('getUserId'))
        const userAnonymous = data.userId
        if (userAnonymous !== ANONIMOUS_USER_CODE) {
          dispatch(ACTION_LOAD_USER)
          dispatch(ACTION_LOAD_MINICART)
          dispatch(ACTION_LOAD_MINIWISHLIST)
          dispatch(ACTION_SAVE_USER_DATA, { userData: data })
        }
      }
    }

    /* TODO: Move this inside header */
    const WCSessionEstablished = Cookies.get(WC_SESSION_ESTABLISHED) === 'true'
    if (wcs.isInPdp()) {
      const { skipSelfAndMyAccountForStella } = wcs.getStoreConfig()

      const selectedProductTypeEl = document.getElementById('producttype')
      const storeconfIsTrue = skipSelfAndMyAccountForStella
      const productIsStella =
        selectedProductTypeEl?.value && isProductStellaByProductType(selectedProductTypeEl.value)
      if (productIsStella) {
        if (!storeconfIsTrue) {
          loadSelfAndMyAccount(WCSessionEstablished)
        }
      } else {
        loadSelfAndMyAccount(WCSessionEstablished)
      }
    } else {
      loadSelfAndMyAccount(WCSessionEstablished)
    }
  },
  [ACTION_EVALUATE_EARLY_ACCESS]: async function ({ dispatch, state }) {
    EarlyAccess.checkAndWriteEarlyAccessCookie()
    const earlyAccessEnabled = EarlyAccess.canPerformEarlyAccessCall()

    const WCSessionEstablished = Cookies.get(WC_SESSION_ESTABLISHED) === 'true'
    if (earlyAccessEnabled) {
      const orderId = state.sidebar.cart.details.orderId
      WcsEarlyAccess.callEarlyAccess(orderId, async () => {
        if (!WCSessionEstablished) {
          await dispatch(ACTION_LOAD_MINICART)
          await dispatch(ACTION_LOAD_MINIWISHLIST)
        }
      })
    }
  },
  [ACTION_EVALUATE_PROMO_CODE]: async function (_, promocode) {
    const queryParams = qs.parse(window.location.search)
    const promoCodeUrl = get(queryParams, '?promo', null) || get(queryParams, 'promo', null)
    const rewardCode = get(queryParams, '?reward', null) || get(queryParams, 'reward', null)
    const saleCode = get(queryParams, '?sale', null) || get(queryParams, 'sale', null)
    const promocodeToApply =
      promocode !== 'REQUEST'
        ? promocode
        : promoCodeUrl
        ? promoCodeUrl
        : rewardCode
        ? rewardCode
        : saleCode
        ? saleCode
        : sessionStorage.getItem('promoCodeToApplyEvaluateQuery')
    if (promocodeToApply) {
      if (window.wcs_config.pageName === SHOP_CART) {
        let deskPromoInput = document.getElementById('D_CartPage_PromoCode_Input')
        let mobPromoInput = document.getElementById('M_CartPage_PromoCode_Input')
        if (deskPromoInput !== null) {
          deskPromoInput.value = promocodeToApply
          document.getElementById('D_CartPage_PromoCode_Apply').click()
        } else if (mobPromoInput !== null) {
          mobPromoInput.value = promocodeToApply
          document.getElementById('M_CartPage_PromoCode_Apply').click()
        }
      } else {
        localStorage.setItem('promoCodeToApply', promocodeToApply)
      }
    }
  },
  [ACTION_SHOW_PAYMENT_MESSAGE_BOX]: function ({ commit }) {
    commit(SHOW_PAYMENT_MESSAGE_BOX)
  },
  [ACTION_HIDE_PAYMENT_MESSAGE_BOX]: function ({ commit }) {
    commit(HIDE_PAYMENT_MESSAGE_BOX)
  },
  [ACTION_SET_KLARNA_EXPRESS_LOADED_STATUS]: function ({ commit }, payload) {
    commit(UPDATE_KLARNA_EXPRESS_LOADED_STATUS, payload)
  },
  [ACTION_SET_KLARNA_EPXRESS_INITIALIZED]: function ({ commit }, payload) {
    commit(UPDATE_KLARNA_EXPRESS_INITIALIZED, payload)
  },
  [ACTION_UPDATE_ROX_PANEL_OVERLAY]: function ({ commit }, payload) {
    commit(UPDATE_ROX_PANEL_OVERLAY, payload)
  },
}
